<mat-form-field>
  <input #inputField
    type="text"
    matInput
    [placeholder]="getSelectedText()"
    [formControl]="searchControl"
    [matAutocomplete]="auto">

  <mat-autocomplete #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelectionChange($event)"
    [panelWidth]="panelWidth">

    <!-- Grouped display mode -->
    @if (grouped) {
      @for (group of filteredGroups | keyvalue; track group) {
        <mat-optgroup
          [label]="group.key"
          class="bold-optgroup">
          @for (item of group.value; track item) {
            <mat-option
              [value]="item.id">
              <div class="option-with-checkbox">
                <mat-checkbox
                  [checked]="isSelected(item.id)"
                  (click)="$event.stopPropagation(); toggleSelection(item.id)">
                  {{item.name}}
                </mat-checkbox>
              </div>
            </mat-option>
          }
        </mat-optgroup>
      }
    }

    <!-- Flat display mode -->
    @if (!grouped) {
      @for (item of filteredFlat; track item) {
        <mat-option
          [value]="item.id">
          <div class="option-with-checkbox">
            <mat-checkbox
              [checked]="isSelected(item.id)"
              (click)="$event.stopPropagation(); toggleSelection(item.id)">
              {{item.name}}
            </mat-checkbox>
          </div>
        </mat-option>
      }
    }
  </mat-autocomplete>

  <!-- Display selected items as chips -->
  @if (getSelectedItems().length) {
    <div class="custom-chips-container">
      @for (item of getSelectedItems(); track item) {
        <div class="custom-chip">
          <mat-icon class="custom-chip-remove" (click)="removeItem(item.id)">cancel</mat-icon>
          <span class="custom-chip-text">{{item.name}}</span>
        </div>
      }
    </div>
  }
</mat-form-field>